import type { RouteObject } from 'react-router';
import { studentNav } from '@/lib/nav/student';
import { collectRoutes } from '../routes';

const modules = import.meta.glob<{ routes: RouteObject[] }>('./*/routes.tsx', { eager: true });

export const studentRoutes = collectRoutes(modules, studentNav, '/student');
